export const Types = {
  GET_MATERIAL_REQUEST: 'GET_MATERIAL_REQUEST',
  GET_HISTORICAL_MATERIAL_REQUEST: 'GET_HISTORICAL_MATERIAL_REQUEST',
  GET_MATERIAL_SUCCESS: 'GET_MATERIAL_SUCCESS',
  SET_MATERIAL_ERROR: 'SET_MATERIAL_ERROR',
  SET_MATERIAL_SELECTION: 'SET_MATERIAL_SELECTION',
  SET_MATERIAL_QUAN: 'SET_MATERIAL_QUAN',
  SET_MATERIAL_FILTER_KEY: 'SET_MATERIAL_FILTER_KEY',
  SET_HISTORICAL_MATERIAL_FILTER: 'SET_HISTORICAL_MATERIAL_FILTER',
  RESET_MATERIALS: 'RESET_MATERIALS',
  ADD_MATERIALS: 'ADD_MATERIALS',
}

export const getMaterialRequest = (kulModelKodu, garantiTipi, hizmetKodu, uyil = 0, udonem = 0) => ({
  type: Types.GET_MATERIAL_REQUEST,
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  uyil,
  udonem,
});

export const getHistoricalMaterialRequest = (kulModelKodu, garantiTipi, hizmetKodu, uyil = 0, udonem = 0) => ({
  type: Types.GET_HISTORICAL_MATERIAL_REQUEST,
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  uyil,
  udonem,
});

export const resetMaterials = () => ({
  type: Types.RESET_MATERIALS,
});

export const addMaterials = (materials) => ({
  type: Types.ADD_MATERIALS,
  payload: (materials)
});


export const getMaterialSuccess = (response) => ({
  type: Types.GET_MATERIAL_SUCCESS,
  payload: response,
});

export const setMaterialError = (error) => ({
  type: Types.SET_MATERIAL_ERROR,
  payload: { error }
});

export const setMaterialSelection = (defect, item) => {
  return ({
    type: Types.SET_MATERIAL_SELECTION,
    payload: { defect, item }
  })
};

export const setMaterialQuan = (material, value) => {
  return ({
    type: Types.SET_MATERIAL_QUAN,
    payload: { material, value }
  })
};

export const setMaterialFilterKey = (value) => {
  return ({
    type: Types.SET_MATERIAL_FILTER_KEY,
    payload: { value }
  })
};

export const setHistoricalMaterialFilter = (value) => {
  return ({
    type: Types.SET_HISTORICAL_MATERIAL_FILTER,
    payload: { value }
  })
};

